__turbopack_context__.v({
  "className": "chivo_f690c54a-module__TyyynW__className",
  "variable": "chivo_f690c54a-module__TyyynW__variable",
});
